"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/date/now"));

var _parseFloat2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-float"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));

var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _StringHelper = _interopRequireDefault(require("../../../../helpers/StringHelper"));

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));

var _Select = _interopRequireDefault(require("@material-ui/core/Select/Select"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _ErgoTargetChooser = require("./ErgoTargetChooser");

var _ergoStrings = require("../../Strings/ergoStrings");

var _MuiAlertHelper = require("../../../../helpers/MuiAlertHelper");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var ErgoUnitsAdder = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ErgoUnitsAdder, _React$Component);

  var _super = _createSuper(ErgoUnitsAdder);

  function ErgoUnitsAdder(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ErgoUnitsAdder);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getDefaultState", function () {
      return {
        units: '',
        valueValid: true,
        showResetDialog: false,
        checked: [],
        monthlySummedUnits: 0,
        contracts: [],
        year: new Date().getFullYear(),
        minYear: new Date().getFullYear()
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_initializeUnitsData", function () {
      var data = _this.getMonthlyUnitsData();

      var summedUnits = _this.getSummedUnitsPerMonth(data.contracts);

      _this.setState({
        monthlySummedUnits: summedUnits,
        contracts: data.contracts,
        minYear: data.minYear
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getMonthlyUnitsData", function () {
      var contracts = [];
      var minYear = new Date().getFullYear();

      _this.props.targetContracts.forEach(function (obj) {
        var date = new Date(obj.date);
        var year = date.getFullYear();
        var month = date.getMonth();

        if (!contracts[year]) {
          contracts[year] = {};
        }

        if (!contracts[year][month]) {
          contracts[year][month] = [];
        }

        contracts[year][month].push(obj);
        minYear = date.getFullYear() < minYear ? date.getFullYear() : minYear;
      });

      return {
        contracts: contracts,
        minYear: minYear
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getSummedUnitsPerMonth", function (contracts) {
      var year = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.year;
      var monthlySummedUnits = [];

      for (var month = 0; month < 12; month++) {
        var sum = 0;

        if (contracts[year] && contracts[year][month]) {
          contracts[year][month].forEach(function (obj) {
            sum += obj.units;
          });
        }

        monthlySummedUnits[month] = sum;
      }

      return monthlySummedUnits;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "deleteMonthlySpecificData", function () {
      var contracts = [];
      var months = [];

      _this.state.checked.forEach(function (isSelected, month) {
        if (isSelected) {
          if (_this.state.contracts[_this.state.year] && _this.state.contracts[_this.state.year][month]) {
            months.push(_ErgoTargetChooser.MONTHS[month]);
            contracts = contracts.concat(_this.state.contracts[_this.state.year][month]);
          }
        }
      });

      if (contracts.length > 0) {
        var resetButton = {
          label: 'Einheiten löschen',
          callback: function callback() {
            _this.props.onReset(contracts);

            _this.props.onClose();

            _this.setState(_this._getDefaultState());
          }
        };
        var cancelButton = {
          label: (0, _ergoStrings.getString)('CANCEL')
        };
        (0, _MuiAlertHelper.showWideAlertHtml)("Sind Sie sicher, dass Sie Einheiten aus den Monaten: ".concat(months.join(', '), " l\xF6schen wollen?"), 'Einheiten löschen', true, [cancelButton, resetButton], true);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleChangeCheckedState", function (index) {
      var checked = (0, _toConsumableArray2["default"])(_this.state.checked);
      checked[index] ^= true;

      _this.setState({
        checked: checked
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleAdd", function () {
      var unitsValid = true;

      if (isNaN(_this.state.units)) {
        unitsValid = false;
      }

      if (unitsValid) {
        var units = Math.round((0, _parseFloat2["default"])(_this.state.units) * 100) / 100;

        _this.props.onClose();

        _this.props.onAdd({
          id: _StringHelper["default"].createShortId(),
          units: units,
          date: (0, _now["default"])()
        });

        _this.setState(_this._getDefaultState());
      } else {
        _this.setState({
          valueValid: unitsValid
        });
      }
    });
    _this.state = _this._getDefaultState();

    _this._initializeUnitsData();

    return _this;
  }

  (0, _createClass2["default"])(ErgoUnitsAdder, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.targetContracts !== this.props.targetContracts) {
        this._initializeUnitsData();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var menuItems = [];

      for (var i = new Date().getFullYear(); i >= this.state.minYear; i--) {
        menuItems.push( /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
          value: i
        }, i));
      }

      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
        open: this.props.open && this.state.showResetDialog,
        onClose: function onClose() {
          return _this2.setState({
            showResetDialog: false
          });
        }
      }, /*#__PURE__*/_react["default"].createElement(_DialogTitle["default"], null, (0, _ergoStrings.getString)('DELETE_UNITS_PER_MONTH')), /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], null, /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/_react["default"].createElement(_InputLabel["default"], {
        htmlFor: "year"
      }, (0, _ergoStrings.getString)('YEAR')), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
        value: this.state.year,
        onChange: function onChange(e) {
          _this2.setState({
            year: e.target.value,
            monthlySummedUnits: _this2.getSummedUnitsPerMonth(_this2.state.contracts, e.target.value)
          });
        },
        inputProps: {
          id: 'year'
        }
      }, menuItems)), /*#__PURE__*/_react["default"].createElement(_FormControl["default"], null, (0, _keys["default"])(_ErgoTargetChooser.MONTHS).map(function (key) {
        return _this2.state.monthlySummedUnits[key] ? /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
          key: key,
          control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
            checked: _this2.state.checked[key],
            onChange: function onChange() {
              return _this2.handleChangeCheckedState(key);
            },
            value: key
          }),
          label: "".concat(_ErgoTargetChooser.MONTHS[key], " ").concat((0, _ergoStrings.getString)('BOOKED_UNITS'), ": ").concat(_this2.state.monthlySummedUnits[key])
        }) : null;
      }))), /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: function onClick() {
          return _this2.setState({
            showResetDialog: false
          });
        }
      }, (0, _ergoStrings.getString)('CANCEL')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: this.deleteMonthlySpecificData
      }, (0, _ergoStrings.getString)('DELETE_UNITS')))), /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
        open: this.props.open,
        onClose: this.props.onClose
      }, /*#__PURE__*/_react["default"].createElement(_DialogTitle["default"], null, (0, _ergoStrings.getString)('BOOK_UNITS')), /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], null, /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
        fullWidth: true,
        error: !this.state.valueValid,
        label: (0, _ergoStrings.getString)('UNITS'),
        type: 'number',
        value: this.state.units,
        onChange: function onChange(e) {
          return _this2.setState({
            units: e.target.value
          });
        }
      })), /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: this.props.onClose
      }, (0, _ergoStrings.getString)('CANCEL')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: function onClick() {
          return _this2.setState({
            showResetDialog: true
          });
        }
      }, (0, _ergoStrings.getString)('RESET_TARGET')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: this.handleAdd
      }, (0, _ergoStrings.getString)('ADD_UNITS')))));
    }
  }]);
  return ErgoUnitsAdder;
}(_react["default"].Component);

ErgoUnitsAdder.propTypes = {
  targetContracts: _propTypes["default"].array.isRequired,
  onReset: _propTypes["default"].func.isRequired,
  onClose: _propTypes["default"].func.isRequired,
  onAdd: _propTypes["default"].func.isRequired,
  open: _propTypes["default"].bool.isRequired
};
var _default = ErgoUnitsAdder;
exports["default"] = _default;